// extracted by mini-css-extract-plugin
export var contentsHeading = "styles-module--contentsHeading--E-Z6-";
export var noContainer = "styles-module--noContainer--KXv6p";